import { z } from "zod";

export const dateRangeSchema = z.object({
  dateRange: z.object({
    from: z.string().date(),
    to: z.string().date(),
  }),
});

export type TDateRange = z.infer<typeof dateRangeSchema>;
